import Home from './Home'
import Account from './Account'
import Common from './Common'
import Rate from './Rate'
import Route from './Route'
import Tag from './Tag'
import Store from './Store'
import Checkout from './Checkout'
import Cart from './Cart'
import Auth from './Auth'
import Offer from './Offer'
import Page from './Page'
import Otp from './Otp'

export default {
  Home    : Home,
  Account : Account,
  Common  : Common,
  Rate    : Rate,
  Route   : Route,
  Tag     : Tag,
  Store   : Store,
  Checkout: Checkout,
  Cart    : Cart,
  Auth    : Auth,
  Offer   : Offer,
  Page    : Page,
  Otp     : Otp
}
